import React from 'react';
import SelectSearchView from 'react-select';

const SelectAndSearchDropDown = ({
  className,
  list,
  selected_value,
  setSelectedValue,
  name,
  default_text,
  title,
  isRequired,
}) => {
  return (
    <div className="space-y-1 w-full  ">
      {title && (
        <p
          className={[
            ' text-gray-600',
            isRequired &&
              "flex-none relative after:content-['*'] after:text-red-500 after:-top-[5px] after:-right-[12px] ",
          ].join(' ')}>
          {' '}
          {title}
        </p>
      )}

      <SelectSearchView
        value={
          selected_value
            ? {
                label: `${selected_value?.label}`,
                value: selected_value?.value,
              }
            : null
        }
        onChange={itm => {
          setSelectedValue(itm);
        }}
        options={list || []}
        isMulti={false}
        placeholder={default_text}
      />
    </div>
  );
};

export default SelectAndSearchDropDown;
